module.exports = __webpack_public_path__ + "img/xicheji_c.9af3520d.png";